<div class="group" [class.seen]="seen" [class.small]="small">
  <div class="people-asset" [class.multiple]="group.people.length > 1">
    @if (!group.people.length) {
      <div class="avatar main">
        <app-svg src="/assets/icons/user.svg" alt=""></app-svg>
      </div>
    }
    @if (group.people.length) {
      <div class="avatar main">
        <app-avatar [user]="group.people[0]"></app-avatar>
      </div>
    }
    @if (group.people.length === 2) {
      <div class="avatar secondary">
        <app-avatar [user]="group.people[1]"></app-avatar>
      </div>
    }
    @if (group.people.length > 2) {
      <div class="avatar secondary">+{{ group.people.length - 1 }}</div>
    }
  </div>
  <div class="text-parent">
    <div class="group-text">
      @for (line of group.text; track line) {
        @if (line.type === 'text') {
          <span>{{ line.content }}</span>
        }
        @if (line.type === 'people') {
          <b (click)="peopleClick($event)">{{ line.content }}</b>
        }
        @if (line.type === 'assets') {
          @if (group.assets.length === 1) {
            <b [appTooltip]="group.assets[0]?.version_data.asset_name">{{ line.content }}</b>
          } @else {
            <b>{{ line.content }}</b>
          }
        }
        @if (line.type === 'gallery') {
          <b>{{ line.content }}</b>
        }
      }
    </div>
    <div class="time" [appTooltip]="(group.endTime | date: 'MMM d, yyyy') + ' at ' + (group.endTime | date: 'HH:mm')">
      {{ group.endTime | relativeTime }}
    </div>
  </div>
  <div class="group-cta" [class.no-asset]="!group.gallery?.teaser?.uuid" [class.no-margin]="context === 'asset'">
    <div class="cta-icon" [attr.bg-color]="group.iconColor">
      <app-svg [src]="group.icon" [attr.color]="group.iconColor === 'grey-10' ? '' : 'white'"></app-svg>
    </div>
    @if (context !== 'asset') {
      <div class="assets">
        @for (asset of group.assets; track asset) {
          @if ((asset | canDisplayAsset) && asset.type !== 'audio') {
            <div class="asset">
              <div class="asset-inner">
                <img
                  [src]="
                    asset.version_data
                      | assetVersionUrl: asset : asset.version_data.status : 50 : 50 : !!group.gallery.watermark
                  "
                  alt=""
                />
              </div>
            </div>
          }
        }
        @if (!group.assetIds.length && group.gallery?.teaser?.uuid) {
          <div class="asset">
            <div class="asset-inner">
              <img
                [src]="group.gallery | galleryTeaserUrl: 32"
                alt=""
                [style.object-position]="
                  group.gallery.teaser?.uuid === group.gallery.cover.uuid ? group.gallery.cover.position : undefined
                "
              />
            </div>
          </div>
        }
      </div>
      @if (group.link) {
        <div class="arrow">
          <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
        </div>
      }
    }
  </div>
</div>
